import React, { Component } from 'react';

export default class RechargeWalletKupospayAgent extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
    };
  }

  render() {
    return (
      <div className="my-account-recharge-wallet-kupospay-agent wallet-item-content">
        <div className="recharge-map-container">
          <div className="white-triangle share-balance"></div>

          <div className="title-and-image">
            <span>
              Recarge tu &nbsp;
              <img src="/images/kupos_pay_logo.png" alt="" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/my-account/RechargeWalletKupospayAgent/RechargeWalletKupospayAgent.js